import { BASE_ASSETS_URL } from "../utils/constants.js"

const AnimalsPage = ({ text }) => {

    //TODO: select better animal image, trim?
    return (
        <div className="drocker-body">
            <div className="position-relative">
                <div className="drocker-responsive-image" style={{ backgroundImage: `url(${BASE_ASSETS_URL}images/pigs_1.jpg)` }}></div>
                <div className="container drocker-h1-container">
                    <h1 className="text-white mb-0 drocker-title-outline">{text.animalsTitle}</h1>
                </div>
            </div>
            <div className="container">
            </div>
        </div>
    )
}

export default AnimalsPage
